import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup,FormControl, Validators } from '@angular/forms';
import { CompanyService } from './../../services/company.service';
import { FactLanguageService } from './../../services/fact-language.service';
import { EncrDecrService } from '../../services/encr-decr.service';
@Component({
  selector: 'app-company-profile',
  templateUrl: './company-profile.component.html',
  styleUrls: ['./company-profile.component.css']
})
export class CompanyProfileComponent implements OnInit {
  user_id: any = '';
  APIKEY: any = '';
  lastDay_of_Week :boolean=false;
  buttonDisabled: boolean;
  model: any = {};
  myDateValue: Date;
  factLanguage: any = {};
  arr: any[] = [];
  key_info: any = {};
  company_id: any = 0;
  edit_factoring_mode: boolean = false;
  modelexpiration_date: any = '';
  factReadOnly: boolean = true;
  currentUserRole: any = '';
  abc: any = [];
  assign_fact_mode = false;
  mobile_reminder_mode = false;
  assign_soa_mode = false;
  minDate: Date;
  maxDate: Date;
  customMinDate = new Date(2017, 5, 10);
  customMaxDate = new Date(2018, 9, 15);
  contentEditable=false;
  constructor(private _company: CompanyService,
    private _factLang: FactLanguageService,
    private _router: Router,
    private toastr: ToastrService,
    private _activatedroute: ActivatedRoute,
    private EncrDecr: EncrDecrService,
    
  ) {
    this.minDate = new Date();
    this.maxDate = new Date();
    this.minDate.setDate(this.minDate.getDate() - 1);
    this.maxDate.setDate(this.maxDate.getDate() + 7);
   }

  ngOnInit() {
    this.user_id = localStorage.getItem('id');
    this.company_id = localStorage.getItem('company_id');
    this.APIKEY = localStorage.getItem('APIKEY');
    this.abc = localStorage.getItem('currentUser');
    var obj = JSON.parse(this.abc);
    this.currentUserRole = obj.role_name;




    this.get_company_by_id();

    this.myDateValue = new Date();

  }

  public onSaveFactLang(value: boolean) {
    if (value == true) {
      this.model["edit_factoring"] = true;
    }
    else {
      this.model["edit_factoring"] = false;
    }
  }

  accOnKey(event: any) {
    //this.model["email_per_invoice"] = event.target.value;
  }




  onSubmit(form) {

    this.model["company_id"] = this.company_id;
    this.model["user_id"] = this.user_id;
    this.model["APIKEY"] = this.APIKEY;
   //console.log(this.model);  return false;   
   var encrypted_id = this.EncrDecr.set(localStorage.getItem('key'), this.model.password);
     this.model.password=encrypted_id;
    this._company.updateCmp(this.model)
      .subscribe(
        res => {
       //  console.log(res); return false;
          if (res.status == true) {
            this.toastr.success(res.message, 'Success');
            window.location.reload();
          }
          else {
            this.toastr.error(res.message, 'Error');
          }
          this._router.navigate(['setting/company-profile/']);

          
        },
      );
  }
  public setAssignSoa(value: boolean) {
    if (value == true) {
      this.model["assign_soa"] = true;
    }
    else {
      this.model["assign_soa"] = false;
    }
   // console.log(this.model);
  }
  public updateItem(value: boolean) {
    if (value == true) {

      this.model["mobile_reminder"]=true;
    
    }
    else{
      this.model["mobile_reminder"]=false;
     
    }
    //console.log(this.model)
  }


  public setAssignFileupload(value: boolean) {
    if (value == true) {
      this.model["assign_fileupload"] = true;
    }
    else {
      this.model["assign_fileupload"] = false;
    }
   // console.log(this.model);
  }

  get_company_by_id() {
    const data = {
      company_id: this.company_id,
      APIKEY: this.APIKEY
    }
    this._company.getCompanyById(data)
      .subscribe(
        res => {

//console.log(res.data);return false;
          if (res.data.edit_factoring == 1) {
            this.edit_factoring_mode = true;
            this.factReadOnly = false;
          }

          if(res.data.assign_soa==1){
            this.assign_soa_mode=true; 
          }
          if(res.data.assign_fileupload==1){
            this.assign_fact_mode=true; 
          }
          if(res.data.mobile_reminder==1){
            this.mobile_reminder_mode=true; 
          }

          this.model["assign_soa"] =res.data.assign_soa;
          this.model["assign_fileupload"] =res.data.assign_fileupload;
          this.model["mobile_reminder"] =res.data.mobile_reminder;
          this.model = res.data;
          this.model.password = this.EncrDecr.get(localStorage.getItem('key'), this.model.password);
          this.onChangeEvent(res.data.recurring);
   //   console.log(this.model);

        },
        err => console.log(err)
      );
  }
 
  myForm = new FormGroup({
    myDateYMD: new FormControl(new Date()),

   
  });

  weekshow:boolean=true;
  weekhide:boolean=false;
  dayshow:boolean=true;
  dayhide:boolean=false;
  onChangeEvent(value:any) {
    if(value=='Weekly') {
      this.weekshow=true; this.weekhide=false;
    }
    else if(value=='lastDay') {
      this.weekshow=false; this.weekhide=true;
    }
   
    this.model['recurring']=value;
    //console.log(this.model);
  }

  onChangeDays(value:any) {
    // if(value=='lastDay') {
    //  this.weekshow=false; this.weekhide=true;
    // }
    // else  {
    //    this.weekshow=true; this.weekhide=false;
    // }
    this.model['due_date']=value;
  }


  onChangeReminderBefore(value:any){
   
    this.model['reminder_day_before']=value;
  //  console.log(this.model);
  }


  onChangeReminderAfter(value:any){
   
    this.model['reminder_day_after']=value;
   // console.log(this.model);
  }
 
 
}



